(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergenDialogController', AllergenDialogController);

    AllergenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Allergen'];

    function AllergenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Allergen) {
        var vm = this;

        vm.allergen = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.allergen.id !== null) {
                Allergen.update(vm.allergen, onSaveSuccess, onSaveError);
            } else {
                Allergen.save(vm.allergen, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:allergenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
